// source: acompanha/filaments/v1/filaments.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js');
goog.object.extend(proto, acompanha_common_v1_common_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.acompanha.filaments.v1.AssignFilamentToPrintersRequest', null, global);
goog.exportSymbol('proto.acompanha.filaments.v1.AssignFilamentToPrintersResponse', null, global);
goog.exportSymbol('proto.acompanha.filaments.v1.CreateFilamentRequest', null, global);
goog.exportSymbol('proto.acompanha.filaments.v1.CreateFilamentResponse', null, global);
goog.exportSymbol('proto.acompanha.filaments.v1.DeleteFilamentRequest', null, global);
goog.exportSymbol('proto.acompanha.filaments.v1.Filament', null, global);
goog.exportSymbol('proto.acompanha.filaments.v1.FilamentListItem', null, global);
goog.exportSymbol('proto.acompanha.filaments.v1.FilamentPrinterAssignInput', null, global);
goog.exportSymbol('proto.acompanha.filaments.v1.FilamentPrinterLink', null, global);
goog.exportSymbol('proto.acompanha.filaments.v1.FilamentUsage', null, global);
goog.exportSymbol('proto.acompanha.filaments.v1.GetFilamentRequest', null, global);
goog.exportSymbol('proto.acompanha.filaments.v1.GetFilamentResponse', null, global);
goog.exportSymbol('proto.acompanha.filaments.v1.ListFilamentUsagesRequest', null, global);
goog.exportSymbol('proto.acompanha.filaments.v1.ListFilamentUsagesResponse', null, global);
goog.exportSymbol('proto.acompanha.filaments.v1.ListFilamentsRequest', null, global);
goog.exportSymbol('proto.acompanha.filaments.v1.ListFilamentsResponse', null, global);
goog.exportSymbol('proto.acompanha.filaments.v1.ListLowStockFilamentsRequest', null, global);
goog.exportSymbol('proto.acompanha.filaments.v1.ListLowStockFilamentsResponse', null, global);
goog.exportSymbol('proto.acompanha.filaments.v1.SetFilamentArchivedRequest', null, global);
goog.exportSymbol('proto.acompanha.filaments.v1.SetFilamentArchivedResponse', null, global);
goog.exportSymbol('proto.acompanha.filaments.v1.UpdateFilamentRequest', null, global);
goog.exportSymbol('proto.acompanha.filaments.v1.UpdateFilamentResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.filaments.v1.FilamentListItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.filaments.v1.FilamentListItem.repeatedFields_, null);
};
goog.inherits(proto.acompanha.filaments.v1.FilamentListItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.filaments.v1.FilamentListItem.displayName = 'proto.acompanha.filaments.v1.FilamentListItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.filaments.v1.FilamentPrinterLink = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.filaments.v1.FilamentPrinterLink, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.filaments.v1.FilamentPrinterLink.displayName = 'proto.acompanha.filaments.v1.FilamentPrinterLink';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.filaments.v1.Filament = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.filaments.v1.Filament, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.filaments.v1.Filament.displayName = 'proto.acompanha.filaments.v1.Filament';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.filaments.v1.ListFilamentsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.filaments.v1.ListFilamentsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.filaments.v1.ListFilamentsRequest.displayName = 'proto.acompanha.filaments.v1.ListFilamentsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.filaments.v1.ListFilamentsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.filaments.v1.ListFilamentsResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.filaments.v1.ListFilamentsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.filaments.v1.ListFilamentsResponse.displayName = 'proto.acompanha.filaments.v1.ListFilamentsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.filaments.v1.ListLowStockFilamentsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.filaments.v1.ListLowStockFilamentsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.filaments.v1.ListLowStockFilamentsRequest.displayName = 'proto.acompanha.filaments.v1.ListLowStockFilamentsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.filaments.v1.ListLowStockFilamentsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.filaments.v1.ListLowStockFilamentsResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.filaments.v1.ListLowStockFilamentsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.filaments.v1.ListLowStockFilamentsResponse.displayName = 'proto.acompanha.filaments.v1.ListLowStockFilamentsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.filaments.v1.GetFilamentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.filaments.v1.GetFilamentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.filaments.v1.GetFilamentRequest.displayName = 'proto.acompanha.filaments.v1.GetFilamentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.filaments.v1.GetFilamentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.filaments.v1.GetFilamentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.filaments.v1.GetFilamentResponse.displayName = 'proto.acompanha.filaments.v1.GetFilamentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.filaments.v1.CreateFilamentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.filaments.v1.CreateFilamentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.filaments.v1.CreateFilamentRequest.displayName = 'proto.acompanha.filaments.v1.CreateFilamentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.filaments.v1.CreateFilamentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.filaments.v1.CreateFilamentResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.filaments.v1.CreateFilamentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.filaments.v1.CreateFilamentResponse.displayName = 'proto.acompanha.filaments.v1.CreateFilamentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.filaments.v1.UpdateFilamentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.filaments.v1.UpdateFilamentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.filaments.v1.UpdateFilamentRequest.displayName = 'proto.acompanha.filaments.v1.UpdateFilamentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.filaments.v1.UpdateFilamentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.filaments.v1.UpdateFilamentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.filaments.v1.UpdateFilamentResponse.displayName = 'proto.acompanha.filaments.v1.UpdateFilamentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.filaments.v1.DeleteFilamentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.filaments.v1.DeleteFilamentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.filaments.v1.DeleteFilamentRequest.displayName = 'proto.acompanha.filaments.v1.DeleteFilamentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.filaments.v1.SetFilamentArchivedRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.filaments.v1.SetFilamentArchivedRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.filaments.v1.SetFilamentArchivedRequest.displayName = 'proto.acompanha.filaments.v1.SetFilamentArchivedRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.filaments.v1.SetFilamentArchivedResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.filaments.v1.SetFilamentArchivedResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.filaments.v1.SetFilamentArchivedResponse.displayName = 'proto.acompanha.filaments.v1.SetFilamentArchivedResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.filaments.v1.FilamentUsage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.filaments.v1.FilamentUsage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.filaments.v1.FilamentUsage.displayName = 'proto.acompanha.filaments.v1.FilamentUsage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.filaments.v1.ListFilamentUsagesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.filaments.v1.ListFilamentUsagesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.filaments.v1.ListFilamentUsagesRequest.displayName = 'proto.acompanha.filaments.v1.ListFilamentUsagesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.filaments.v1.ListFilamentUsagesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.filaments.v1.ListFilamentUsagesResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.filaments.v1.ListFilamentUsagesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.filaments.v1.ListFilamentUsagesResponse.displayName = 'proto.acompanha.filaments.v1.ListFilamentUsagesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.filaments.v1.FilamentPrinterAssignInput = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.filaments.v1.FilamentPrinterAssignInput, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.filaments.v1.FilamentPrinterAssignInput.displayName = 'proto.acompanha.filaments.v1.FilamentPrinterAssignInput';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.filaments.v1.AssignFilamentToPrintersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.filaments.v1.AssignFilamentToPrintersRequest.repeatedFields_, null);
};
goog.inherits(proto.acompanha.filaments.v1.AssignFilamentToPrintersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.filaments.v1.AssignFilamentToPrintersRequest.displayName = 'proto.acompanha.filaments.v1.AssignFilamentToPrintersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.filaments.v1.AssignFilamentToPrintersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.filaments.v1.AssignFilamentToPrintersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.filaments.v1.AssignFilamentToPrintersResponse.displayName = 'proto.acompanha.filaments.v1.AssignFilamentToPrintersResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.filaments.v1.FilamentListItem.repeatedFields_ = [12];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.filaments.v1.FilamentListItem.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.filaments.v1.FilamentListItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.filaments.v1.FilamentListItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.FilamentListItem.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
type: jspb.Message.getFieldWithDefault(msg, 2, ""),
color: jspb.Message.getFieldWithDefault(msg, 3, ""),
brand: jspb.Message.getFieldWithDefault(msg, 4, ""),
spoolWeight: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
currentWeight: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
cost: jspb.Message.getFieldWithDefault(msg, 7, 0),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
colorLabel: jspb.Message.getFieldWithDefault(msg, 9, ""),
usageCount: jspb.Message.getFieldWithDefault(msg, 10, 0),
archivedAt: (f = msg.getArchivedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
printersList: jspb.Message.toObjectList(msg.getPrintersList(),
    proto.acompanha.filaments.v1.FilamentPrinterLink.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.filaments.v1.FilamentListItem}
 */
proto.acompanha.filaments.v1.FilamentListItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.filaments.v1.FilamentListItem;
  return proto.acompanha.filaments.v1.FilamentListItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.filaments.v1.FilamentListItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.filaments.v1.FilamentListItem}
 */
proto.acompanha.filaments.v1.FilamentListItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setColor(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrand(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSpoolWeight(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCurrentWeight(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCost(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setColorLabel(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUsageCount(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setArchivedAt(value);
      break;
    case 12:
      var value = new proto.acompanha.filaments.v1.FilamentPrinterLink;
      reader.readMessage(value,proto.acompanha.filaments.v1.FilamentPrinterLink.deserializeBinaryFromReader);
      msg.addPrinters(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.filaments.v1.FilamentListItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.filaments.v1.FilamentListItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.filaments.v1.FilamentListItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.FilamentListItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getColor();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBrand();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSpoolWeight();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getCurrentWeight();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getCost();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getColorLabel();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getUsageCount();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getArchivedAt();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPrintersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      12,
      f,
      proto.acompanha.filaments.v1.FilamentPrinterLink.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.acompanha.filaments.v1.FilamentListItem.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.FilamentListItem} returns this
 */
proto.acompanha.filaments.v1.FilamentListItem.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string type = 2;
 * @return {string}
 */
proto.acompanha.filaments.v1.FilamentListItem.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.FilamentListItem} returns this
 */
proto.acompanha.filaments.v1.FilamentListItem.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string color = 3;
 * @return {string}
 */
proto.acompanha.filaments.v1.FilamentListItem.prototype.getColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.FilamentListItem} returns this
 */
proto.acompanha.filaments.v1.FilamentListItem.prototype.setColor = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string brand = 4;
 * @return {string}
 */
proto.acompanha.filaments.v1.FilamentListItem.prototype.getBrand = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.FilamentListItem} returns this
 */
proto.acompanha.filaments.v1.FilamentListItem.prototype.setBrand = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional double spool_weight = 5;
 * @return {number}
 */
proto.acompanha.filaments.v1.FilamentListItem.prototype.getSpoolWeight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.filaments.v1.FilamentListItem} returns this
 */
proto.acompanha.filaments.v1.FilamentListItem.prototype.setSpoolWeight = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double current_weight = 6;
 * @return {number}
 */
proto.acompanha.filaments.v1.FilamentListItem.prototype.getCurrentWeight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.filaments.v1.FilamentListItem} returns this
 */
proto.acompanha.filaments.v1.FilamentListItem.prototype.setCurrentWeight = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional int64 cost = 7;
 * @return {number}
 */
proto.acompanha.filaments.v1.FilamentListItem.prototype.getCost = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.filaments.v1.FilamentListItem} returns this
 */
proto.acompanha.filaments.v1.FilamentListItem.prototype.setCost = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.filaments.v1.FilamentListItem.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.filaments.v1.FilamentListItem} returns this
*/
proto.acompanha.filaments.v1.FilamentListItem.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.filaments.v1.FilamentListItem} returns this
 */
proto.acompanha.filaments.v1.FilamentListItem.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.filaments.v1.FilamentListItem.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string color_label = 9;
 * @return {string}
 */
proto.acompanha.filaments.v1.FilamentListItem.prototype.getColorLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.FilamentListItem} returns this
 */
proto.acompanha.filaments.v1.FilamentListItem.prototype.setColorLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional int32 usage_count = 10;
 * @return {number}
 */
proto.acompanha.filaments.v1.FilamentListItem.prototype.getUsageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.filaments.v1.FilamentListItem} returns this
 */
proto.acompanha.filaments.v1.FilamentListItem.prototype.setUsageCount = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional google.protobuf.Timestamp archived_at = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.filaments.v1.FilamentListItem.prototype.getArchivedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.filaments.v1.FilamentListItem} returns this
*/
proto.acompanha.filaments.v1.FilamentListItem.prototype.setArchivedAt = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.filaments.v1.FilamentListItem} returns this
 */
proto.acompanha.filaments.v1.FilamentListItem.prototype.clearArchivedAt = function() {
  return this.setArchivedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.filaments.v1.FilamentListItem.prototype.hasArchivedAt = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * repeated FilamentPrinterLink printers = 12;
 * @return {!Array<!proto.acompanha.filaments.v1.FilamentPrinterLink>}
 */
proto.acompanha.filaments.v1.FilamentListItem.prototype.getPrintersList = function() {
  return /** @type{!Array<!proto.acompanha.filaments.v1.FilamentPrinterLink>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.filaments.v1.FilamentPrinterLink, 12));
};


/**
 * @param {!Array<!proto.acompanha.filaments.v1.FilamentPrinterLink>} value
 * @return {!proto.acompanha.filaments.v1.FilamentListItem} returns this
*/
proto.acompanha.filaments.v1.FilamentListItem.prototype.setPrintersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 12, value);
};


/**
 * @param {!proto.acompanha.filaments.v1.FilamentPrinterLink=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.filaments.v1.FilamentPrinterLink}
 */
proto.acompanha.filaments.v1.FilamentListItem.prototype.addPrinters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.acompanha.filaments.v1.FilamentPrinterLink, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.filaments.v1.FilamentListItem} returns this
 */
proto.acompanha.filaments.v1.FilamentListItem.prototype.clearPrintersList = function() {
  return this.setPrintersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.filaments.v1.FilamentPrinterLink.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.filaments.v1.FilamentPrinterLink.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.filaments.v1.FilamentPrinterLink} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.FilamentPrinterLink.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
assignmentUuid: jspb.Message.getFieldWithDefault(msg, 3, ""),
location: jspb.Message.getFieldWithDefault(msg, 4, ""),
sortOrder: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.filaments.v1.FilamentPrinterLink}
 */
proto.acompanha.filaments.v1.FilamentPrinterLink.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.filaments.v1.FilamentPrinterLink;
  return proto.acompanha.filaments.v1.FilamentPrinterLink.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.filaments.v1.FilamentPrinterLink} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.filaments.v1.FilamentPrinterLink}
 */
proto.acompanha.filaments.v1.FilamentPrinterLink.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssignmentUuid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocation(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSortOrder(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.filaments.v1.FilamentPrinterLink.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.filaments.v1.FilamentPrinterLink.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.filaments.v1.FilamentPrinterLink} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.FilamentPrinterLink.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAssignmentUuid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLocation();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSortOrder();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.filaments.v1.FilamentPrinterLink.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.FilamentPrinterLink} returns this
 */
proto.acompanha.filaments.v1.FilamentPrinterLink.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.acompanha.filaments.v1.FilamentPrinterLink.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.FilamentPrinterLink} returns this
 */
proto.acompanha.filaments.v1.FilamentPrinterLink.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string assignment_uuid = 3;
 * @return {string}
 */
proto.acompanha.filaments.v1.FilamentPrinterLink.prototype.getAssignmentUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.FilamentPrinterLink} returns this
 */
proto.acompanha.filaments.v1.FilamentPrinterLink.prototype.setAssignmentUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string location = 4;
 * @return {string}
 */
proto.acompanha.filaments.v1.FilamentPrinterLink.prototype.getLocation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.FilamentPrinterLink} returns this
 */
proto.acompanha.filaments.v1.FilamentPrinterLink.prototype.setLocation = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 sort_order = 5;
 * @return {number}
 */
proto.acompanha.filaments.v1.FilamentPrinterLink.prototype.getSortOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.filaments.v1.FilamentPrinterLink} returns this
 */
proto.acompanha.filaments.v1.FilamentPrinterLink.prototype.setSortOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.filaments.v1.Filament.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.filaments.v1.Filament.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.filaments.v1.Filament} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.Filament.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
type: jspb.Message.getFieldWithDefault(msg, 2, ""),
color: jspb.Message.getFieldWithDefault(msg, 3, ""),
brand: jspb.Message.getFieldWithDefault(msg, 4, ""),
spoolWeight: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
currentWeight: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
cost: jspb.Message.getFieldWithDefault(msg, 7, 0),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
colorLabel: jspb.Message.getFieldWithDefault(msg, 10, ""),
usageCount: jspb.Message.getFieldWithDefault(msg, 11, 0),
archivedAt: (f = msg.getArchivedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.filaments.v1.Filament}
 */
proto.acompanha.filaments.v1.Filament.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.filaments.v1.Filament;
  return proto.acompanha.filaments.v1.Filament.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.filaments.v1.Filament} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.filaments.v1.Filament}
 */
proto.acompanha.filaments.v1.Filament.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setColor(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrand(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSpoolWeight(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCurrentWeight(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCost(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setColorLabel(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUsageCount(value);
      break;
    case 12:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setArchivedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.filaments.v1.Filament.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.filaments.v1.Filament.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.filaments.v1.Filament} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.Filament.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getColor();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBrand();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSpoolWeight();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getCurrentWeight();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getCost();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getColorLabel();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getUsageCount();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getArchivedAt();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.filaments.v1.Filament.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.Filament} returns this
 */
proto.acompanha.filaments.v1.Filament.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string type = 2;
 * @return {string}
 */
proto.acompanha.filaments.v1.Filament.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.Filament} returns this
 */
proto.acompanha.filaments.v1.Filament.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string color = 3;
 * @return {string}
 */
proto.acompanha.filaments.v1.Filament.prototype.getColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.Filament} returns this
 */
proto.acompanha.filaments.v1.Filament.prototype.setColor = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string brand = 4;
 * @return {string}
 */
proto.acompanha.filaments.v1.Filament.prototype.getBrand = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.Filament} returns this
 */
proto.acompanha.filaments.v1.Filament.prototype.setBrand = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional double spool_weight = 5;
 * @return {number}
 */
proto.acompanha.filaments.v1.Filament.prototype.getSpoolWeight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.filaments.v1.Filament} returns this
 */
proto.acompanha.filaments.v1.Filament.prototype.setSpoolWeight = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double current_weight = 6;
 * @return {number}
 */
proto.acompanha.filaments.v1.Filament.prototype.getCurrentWeight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.filaments.v1.Filament} returns this
 */
proto.acompanha.filaments.v1.Filament.prototype.setCurrentWeight = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional int64 cost = 7;
 * @return {number}
 */
proto.acompanha.filaments.v1.Filament.prototype.getCost = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.filaments.v1.Filament} returns this
 */
proto.acompanha.filaments.v1.Filament.prototype.setCost = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.filaments.v1.Filament.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.filaments.v1.Filament} returns this
*/
proto.acompanha.filaments.v1.Filament.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.filaments.v1.Filament} returns this
 */
proto.acompanha.filaments.v1.Filament.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.filaments.v1.Filament.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.filaments.v1.Filament.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.filaments.v1.Filament} returns this
*/
proto.acompanha.filaments.v1.Filament.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.filaments.v1.Filament} returns this
 */
proto.acompanha.filaments.v1.Filament.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.filaments.v1.Filament.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string color_label = 10;
 * @return {string}
 */
proto.acompanha.filaments.v1.Filament.prototype.getColorLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.Filament} returns this
 */
proto.acompanha.filaments.v1.Filament.prototype.setColorLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional int32 usage_count = 11;
 * @return {number}
 */
proto.acompanha.filaments.v1.Filament.prototype.getUsageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.filaments.v1.Filament} returns this
 */
proto.acompanha.filaments.v1.Filament.prototype.setUsageCount = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional google.protobuf.Timestamp archived_at = 12;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.filaments.v1.Filament.prototype.getArchivedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 12));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.filaments.v1.Filament} returns this
*/
proto.acompanha.filaments.v1.Filament.prototype.setArchivedAt = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.filaments.v1.Filament} returns this
 */
proto.acompanha.filaments.v1.Filament.prototype.clearArchivedAt = function() {
  return this.setArchivedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.filaments.v1.Filament.prototype.hasArchivedAt = function() {
  return jspb.Message.getField(this, 12) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.filaments.v1.ListFilamentsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.filaments.v1.ListFilamentsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.filaments.v1.ListFilamentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.ListFilamentsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
pagination: (f = msg.getPagination()) && acompanha_common_v1_common_pb.PaginationRequest.toObject(includeInstance, f),
archived: jspb.Message.getFieldWithDefault(msg, 2, ""),
sortBy: jspb.Message.getFieldWithDefault(msg, 3, ""),
sortOrder: jspb.Message.getFieldWithDefault(msg, 4, ""),
assignmentScope: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.filaments.v1.ListFilamentsRequest}
 */
proto.acompanha.filaments.v1.ListFilamentsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.filaments.v1.ListFilamentsRequest;
  return proto.acompanha.filaments.v1.ListFilamentsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.filaments.v1.ListFilamentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.filaments.v1.ListFilamentsRequest}
 */
proto.acompanha.filaments.v1.ListFilamentsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new acompanha_common_v1_common_pb.PaginationRequest;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaginationRequest.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchived(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSortBy(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSortOrder(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssignmentScope(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.filaments.v1.ListFilamentsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.filaments.v1.ListFilamentsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.filaments.v1.ListFilamentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.ListFilamentsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      acompanha_common_v1_common_pb.PaginationRequest.serializeBinaryToWriter
    );
  }
  f = message.getArchived();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSortBy();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSortOrder();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAssignmentScope();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional acompanha.common.v1.PaginationRequest pagination = 1;
 * @return {?proto.acompanha.common.v1.PaginationRequest}
 */
proto.acompanha.filaments.v1.ListFilamentsRequest.prototype.getPagination = function() {
  return /** @type{?proto.acompanha.common.v1.PaginationRequest} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaginationRequest, 1));
};


/**
 * @param {?proto.acompanha.common.v1.PaginationRequest|undefined} value
 * @return {!proto.acompanha.filaments.v1.ListFilamentsRequest} returns this
*/
proto.acompanha.filaments.v1.ListFilamentsRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.filaments.v1.ListFilamentsRequest} returns this
 */
proto.acompanha.filaments.v1.ListFilamentsRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.filaments.v1.ListFilamentsRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string archived = 2;
 * @return {string}
 */
proto.acompanha.filaments.v1.ListFilamentsRequest.prototype.getArchived = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.ListFilamentsRequest} returns this
 */
proto.acompanha.filaments.v1.ListFilamentsRequest.prototype.setArchived = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string sort_by = 3;
 * @return {string}
 */
proto.acompanha.filaments.v1.ListFilamentsRequest.prototype.getSortBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.ListFilamentsRequest} returns this
 */
proto.acompanha.filaments.v1.ListFilamentsRequest.prototype.setSortBy = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string sort_order = 4;
 * @return {string}
 */
proto.acompanha.filaments.v1.ListFilamentsRequest.prototype.getSortOrder = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.ListFilamentsRequest} returns this
 */
proto.acompanha.filaments.v1.ListFilamentsRequest.prototype.setSortOrder = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string assignment_scope = 5;
 * @return {string}
 */
proto.acompanha.filaments.v1.ListFilamentsRequest.prototype.getAssignmentScope = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.ListFilamentsRequest} returns this
 */
proto.acompanha.filaments.v1.ListFilamentsRequest.prototype.setAssignmentScope = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.filaments.v1.ListFilamentsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.filaments.v1.ListFilamentsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.filaments.v1.ListFilamentsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.filaments.v1.ListFilamentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.ListFilamentsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
materialsList: jspb.Message.toObjectList(msg.getMaterialsList(),
    proto.acompanha.filaments.v1.FilamentListItem.toObject, includeInstance),
meta: (f = msg.getMeta()) && acompanha_common_v1_common_pb.PaginationMeta.toObject(includeInstance, f),
archivedTotal: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.filaments.v1.ListFilamentsResponse}
 */
proto.acompanha.filaments.v1.ListFilamentsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.filaments.v1.ListFilamentsResponse;
  return proto.acompanha.filaments.v1.ListFilamentsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.filaments.v1.ListFilamentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.filaments.v1.ListFilamentsResponse}
 */
proto.acompanha.filaments.v1.ListFilamentsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.filaments.v1.FilamentListItem;
      reader.readMessage(value,proto.acompanha.filaments.v1.FilamentListItem.deserializeBinaryFromReader);
      msg.addMaterials(value);
      break;
    case 2:
      var value = new acompanha_common_v1_common_pb.PaginationMeta;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaginationMeta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setArchivedTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.filaments.v1.ListFilamentsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.filaments.v1.ListFilamentsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.filaments.v1.ListFilamentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.ListFilamentsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMaterialsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.acompanha.filaments.v1.FilamentListItem.serializeBinaryToWriter
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      acompanha_common_v1_common_pb.PaginationMeta.serializeBinaryToWriter
    );
  }
  f = message.getArchivedTotal();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * repeated FilamentListItem materials = 1;
 * @return {!Array<!proto.acompanha.filaments.v1.FilamentListItem>}
 */
proto.acompanha.filaments.v1.ListFilamentsResponse.prototype.getMaterialsList = function() {
  return /** @type{!Array<!proto.acompanha.filaments.v1.FilamentListItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.filaments.v1.FilamentListItem, 1));
};


/**
 * @param {!Array<!proto.acompanha.filaments.v1.FilamentListItem>} value
 * @return {!proto.acompanha.filaments.v1.ListFilamentsResponse} returns this
*/
proto.acompanha.filaments.v1.ListFilamentsResponse.prototype.setMaterialsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.acompanha.filaments.v1.FilamentListItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.filaments.v1.FilamentListItem}
 */
proto.acompanha.filaments.v1.ListFilamentsResponse.prototype.addMaterials = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.acompanha.filaments.v1.FilamentListItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.filaments.v1.ListFilamentsResponse} returns this
 */
proto.acompanha.filaments.v1.ListFilamentsResponse.prototype.clearMaterialsList = function() {
  return this.setMaterialsList([]);
};


/**
 * optional acompanha.common.v1.PaginationMeta meta = 2;
 * @return {?proto.acompanha.common.v1.PaginationMeta}
 */
proto.acompanha.filaments.v1.ListFilamentsResponse.prototype.getMeta = function() {
  return /** @type{?proto.acompanha.common.v1.PaginationMeta} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaginationMeta, 2));
};


/**
 * @param {?proto.acompanha.common.v1.PaginationMeta|undefined} value
 * @return {!proto.acompanha.filaments.v1.ListFilamentsResponse} returns this
*/
proto.acompanha.filaments.v1.ListFilamentsResponse.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.filaments.v1.ListFilamentsResponse} returns this
 */
proto.acompanha.filaments.v1.ListFilamentsResponse.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.filaments.v1.ListFilamentsResponse.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 archived_total = 3;
 * @return {number}
 */
proto.acompanha.filaments.v1.ListFilamentsResponse.prototype.getArchivedTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.filaments.v1.ListFilamentsResponse} returns this
 */
proto.acompanha.filaments.v1.ListFilamentsResponse.prototype.setArchivedTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.filaments.v1.ListLowStockFilamentsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.filaments.v1.ListLowStockFilamentsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.filaments.v1.ListLowStockFilamentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.ListLowStockFilamentsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.filaments.v1.ListLowStockFilamentsRequest}
 */
proto.acompanha.filaments.v1.ListLowStockFilamentsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.filaments.v1.ListLowStockFilamentsRequest;
  return proto.acompanha.filaments.v1.ListLowStockFilamentsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.filaments.v1.ListLowStockFilamentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.filaments.v1.ListLowStockFilamentsRequest}
 */
proto.acompanha.filaments.v1.ListLowStockFilamentsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.filaments.v1.ListLowStockFilamentsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.filaments.v1.ListLowStockFilamentsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.filaments.v1.ListLowStockFilamentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.ListLowStockFilamentsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.filaments.v1.ListLowStockFilamentsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.filaments.v1.ListLowStockFilamentsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.filaments.v1.ListLowStockFilamentsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.filaments.v1.ListLowStockFilamentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.ListLowStockFilamentsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
materialsList: jspb.Message.toObjectList(msg.getMaterialsList(),
    proto.acompanha.filaments.v1.FilamentListItem.toObject, includeInstance),
total: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.filaments.v1.ListLowStockFilamentsResponse}
 */
proto.acompanha.filaments.v1.ListLowStockFilamentsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.filaments.v1.ListLowStockFilamentsResponse;
  return proto.acompanha.filaments.v1.ListLowStockFilamentsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.filaments.v1.ListLowStockFilamentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.filaments.v1.ListLowStockFilamentsResponse}
 */
proto.acompanha.filaments.v1.ListLowStockFilamentsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.filaments.v1.FilamentListItem;
      reader.readMessage(value,proto.acompanha.filaments.v1.FilamentListItem.deserializeBinaryFromReader);
      msg.addMaterials(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.filaments.v1.ListLowStockFilamentsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.filaments.v1.ListLowStockFilamentsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.filaments.v1.ListLowStockFilamentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.ListLowStockFilamentsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMaterialsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.acompanha.filaments.v1.FilamentListItem.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * repeated FilamentListItem materials = 1;
 * @return {!Array<!proto.acompanha.filaments.v1.FilamentListItem>}
 */
proto.acompanha.filaments.v1.ListLowStockFilamentsResponse.prototype.getMaterialsList = function() {
  return /** @type{!Array<!proto.acompanha.filaments.v1.FilamentListItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.filaments.v1.FilamentListItem, 1));
};


/**
 * @param {!Array<!proto.acompanha.filaments.v1.FilamentListItem>} value
 * @return {!proto.acompanha.filaments.v1.ListLowStockFilamentsResponse} returns this
*/
proto.acompanha.filaments.v1.ListLowStockFilamentsResponse.prototype.setMaterialsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.acompanha.filaments.v1.FilamentListItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.filaments.v1.FilamentListItem}
 */
proto.acompanha.filaments.v1.ListLowStockFilamentsResponse.prototype.addMaterials = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.acompanha.filaments.v1.FilamentListItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.filaments.v1.ListLowStockFilamentsResponse} returns this
 */
proto.acompanha.filaments.v1.ListLowStockFilamentsResponse.prototype.clearMaterialsList = function() {
  return this.setMaterialsList([]);
};


/**
 * optional int32 total = 2;
 * @return {number}
 */
proto.acompanha.filaments.v1.ListLowStockFilamentsResponse.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.filaments.v1.ListLowStockFilamentsResponse} returns this
 */
proto.acompanha.filaments.v1.ListLowStockFilamentsResponse.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.filaments.v1.GetFilamentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.filaments.v1.GetFilamentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.filaments.v1.GetFilamentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.GetFilamentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.filaments.v1.GetFilamentRequest}
 */
proto.acompanha.filaments.v1.GetFilamentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.filaments.v1.GetFilamentRequest;
  return proto.acompanha.filaments.v1.GetFilamentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.filaments.v1.GetFilamentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.filaments.v1.GetFilamentRequest}
 */
proto.acompanha.filaments.v1.GetFilamentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.filaments.v1.GetFilamentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.filaments.v1.GetFilamentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.filaments.v1.GetFilamentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.GetFilamentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.filaments.v1.GetFilamentRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.GetFilamentRequest} returns this
 */
proto.acompanha.filaments.v1.GetFilamentRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.filaments.v1.GetFilamentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.filaments.v1.GetFilamentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.filaments.v1.GetFilamentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.GetFilamentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.filaments.v1.Filament.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.filaments.v1.GetFilamentResponse}
 */
proto.acompanha.filaments.v1.GetFilamentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.filaments.v1.GetFilamentResponse;
  return proto.acompanha.filaments.v1.GetFilamentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.filaments.v1.GetFilamentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.filaments.v1.GetFilamentResponse}
 */
proto.acompanha.filaments.v1.GetFilamentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.filaments.v1.Filament;
      reader.readMessage(value,proto.acompanha.filaments.v1.Filament.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.filaments.v1.GetFilamentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.filaments.v1.GetFilamentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.filaments.v1.GetFilamentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.GetFilamentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.filaments.v1.Filament.serializeBinaryToWriter
    );
  }
};


/**
 * optional Filament data = 1;
 * @return {?proto.acompanha.filaments.v1.Filament}
 */
proto.acompanha.filaments.v1.GetFilamentResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.filaments.v1.Filament} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.filaments.v1.Filament, 1));
};


/**
 * @param {?proto.acompanha.filaments.v1.Filament|undefined} value
 * @return {!proto.acompanha.filaments.v1.GetFilamentResponse} returns this
*/
proto.acompanha.filaments.v1.GetFilamentResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.filaments.v1.GetFilamentResponse} returns this
 */
proto.acompanha.filaments.v1.GetFilamentResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.filaments.v1.GetFilamentResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.filaments.v1.CreateFilamentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.filaments.v1.CreateFilamentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.filaments.v1.CreateFilamentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.CreateFilamentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
type: jspb.Message.getFieldWithDefault(msg, 1, ""),
color: jspb.Message.getFieldWithDefault(msg, 2, ""),
brand: jspb.Message.getFieldWithDefault(msg, 3, ""),
spoolWeight: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
currentWeight: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
cost: jspb.Message.getFieldWithDefault(msg, 6, 0),
colorLabel: jspb.Message.getFieldWithDefault(msg, 7, ""),
quantity: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.filaments.v1.CreateFilamentRequest}
 */
proto.acompanha.filaments.v1.CreateFilamentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.filaments.v1.CreateFilamentRequest;
  return proto.acompanha.filaments.v1.CreateFilamentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.filaments.v1.CreateFilamentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.filaments.v1.CreateFilamentRequest}
 */
proto.acompanha.filaments.v1.CreateFilamentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setColor(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrand(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSpoolWeight(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCurrentWeight(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCost(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setColorLabel(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.filaments.v1.CreateFilamentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.filaments.v1.CreateFilamentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.filaments.v1.CreateFilamentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.CreateFilamentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getColor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBrand();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSpoolWeight();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getCurrentWeight();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getCost();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getColorLabel();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
};


/**
 * optional string type = 1;
 * @return {string}
 */
proto.acompanha.filaments.v1.CreateFilamentRequest.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.CreateFilamentRequest} returns this
 */
proto.acompanha.filaments.v1.CreateFilamentRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string color = 2;
 * @return {string}
 */
proto.acompanha.filaments.v1.CreateFilamentRequest.prototype.getColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.CreateFilamentRequest} returns this
 */
proto.acompanha.filaments.v1.CreateFilamentRequest.prototype.setColor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string brand = 3;
 * @return {string}
 */
proto.acompanha.filaments.v1.CreateFilamentRequest.prototype.getBrand = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.CreateFilamentRequest} returns this
 */
proto.acompanha.filaments.v1.CreateFilamentRequest.prototype.setBrand = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional double spool_weight = 4;
 * @return {number}
 */
proto.acompanha.filaments.v1.CreateFilamentRequest.prototype.getSpoolWeight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.filaments.v1.CreateFilamentRequest} returns this
 */
proto.acompanha.filaments.v1.CreateFilamentRequest.prototype.setSpoolWeight = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double current_weight = 5;
 * @return {number}
 */
proto.acompanha.filaments.v1.CreateFilamentRequest.prototype.getCurrentWeight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.filaments.v1.CreateFilamentRequest} returns this
 */
proto.acompanha.filaments.v1.CreateFilamentRequest.prototype.setCurrentWeight = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional int64 cost = 6;
 * @return {number}
 */
proto.acompanha.filaments.v1.CreateFilamentRequest.prototype.getCost = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.filaments.v1.CreateFilamentRequest} returns this
 */
proto.acompanha.filaments.v1.CreateFilamentRequest.prototype.setCost = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string color_label = 7;
 * @return {string}
 */
proto.acompanha.filaments.v1.CreateFilamentRequest.prototype.getColorLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.CreateFilamentRequest} returns this
 */
proto.acompanha.filaments.v1.CreateFilamentRequest.prototype.setColorLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int32 quantity = 8;
 * @return {number}
 */
proto.acompanha.filaments.v1.CreateFilamentRequest.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.filaments.v1.CreateFilamentRequest} returns this
 */
proto.acompanha.filaments.v1.CreateFilamentRequest.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.filaments.v1.CreateFilamentResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.filaments.v1.CreateFilamentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.filaments.v1.CreateFilamentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.filaments.v1.CreateFilamentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.CreateFilamentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.filaments.v1.Filament.toObject(includeInstance, f),
createdList: jspb.Message.toObjectList(msg.getCreatedList(),
    proto.acompanha.filaments.v1.Filament.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.filaments.v1.CreateFilamentResponse}
 */
proto.acompanha.filaments.v1.CreateFilamentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.filaments.v1.CreateFilamentResponse;
  return proto.acompanha.filaments.v1.CreateFilamentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.filaments.v1.CreateFilamentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.filaments.v1.CreateFilamentResponse}
 */
proto.acompanha.filaments.v1.CreateFilamentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.filaments.v1.Filament;
      reader.readMessage(value,proto.acompanha.filaments.v1.Filament.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    case 2:
      var value = new proto.acompanha.filaments.v1.Filament;
      reader.readMessage(value,proto.acompanha.filaments.v1.Filament.deserializeBinaryFromReader);
      msg.addCreated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.filaments.v1.CreateFilamentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.filaments.v1.CreateFilamentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.filaments.v1.CreateFilamentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.CreateFilamentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.filaments.v1.Filament.serializeBinaryToWriter
    );
  }
  f = message.getCreatedList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.acompanha.filaments.v1.Filament.serializeBinaryToWriter
    );
  }
};


/**
 * optional Filament data = 1;
 * @return {?proto.acompanha.filaments.v1.Filament}
 */
proto.acompanha.filaments.v1.CreateFilamentResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.filaments.v1.Filament} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.filaments.v1.Filament, 1));
};


/**
 * @param {?proto.acompanha.filaments.v1.Filament|undefined} value
 * @return {!proto.acompanha.filaments.v1.CreateFilamentResponse} returns this
*/
proto.acompanha.filaments.v1.CreateFilamentResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.filaments.v1.CreateFilamentResponse} returns this
 */
proto.acompanha.filaments.v1.CreateFilamentResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.filaments.v1.CreateFilamentResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated Filament created = 2;
 * @return {!Array<!proto.acompanha.filaments.v1.Filament>}
 */
proto.acompanha.filaments.v1.CreateFilamentResponse.prototype.getCreatedList = function() {
  return /** @type{!Array<!proto.acompanha.filaments.v1.Filament>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.filaments.v1.Filament, 2));
};


/**
 * @param {!Array<!proto.acompanha.filaments.v1.Filament>} value
 * @return {!proto.acompanha.filaments.v1.CreateFilamentResponse} returns this
*/
proto.acompanha.filaments.v1.CreateFilamentResponse.prototype.setCreatedList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.acompanha.filaments.v1.Filament=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.filaments.v1.Filament}
 */
proto.acompanha.filaments.v1.CreateFilamentResponse.prototype.addCreated = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.acompanha.filaments.v1.Filament, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.filaments.v1.CreateFilamentResponse} returns this
 */
proto.acompanha.filaments.v1.CreateFilamentResponse.prototype.clearCreatedList = function() {
  return this.setCreatedList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.filaments.v1.UpdateFilamentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.filaments.v1.UpdateFilamentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.filaments.v1.UpdateFilamentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.UpdateFilamentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
type: jspb.Message.getFieldWithDefault(msg, 2, ""),
color: jspb.Message.getFieldWithDefault(msg, 3, ""),
brand: jspb.Message.getFieldWithDefault(msg, 4, ""),
spoolWeight: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
currentWeight: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
cost: jspb.Message.getFieldWithDefault(msg, 7, 0),
colorLabel: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.filaments.v1.UpdateFilamentRequest}
 */
proto.acompanha.filaments.v1.UpdateFilamentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.filaments.v1.UpdateFilamentRequest;
  return proto.acompanha.filaments.v1.UpdateFilamentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.filaments.v1.UpdateFilamentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.filaments.v1.UpdateFilamentRequest}
 */
proto.acompanha.filaments.v1.UpdateFilamentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setColor(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrand(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSpoolWeight(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCurrentWeight(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCost(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setColorLabel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.filaments.v1.UpdateFilamentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.filaments.v1.UpdateFilamentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.filaments.v1.UpdateFilamentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.UpdateFilamentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getColor();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBrand();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSpoolWeight();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getCurrentWeight();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getCost();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getColorLabel();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.filaments.v1.UpdateFilamentRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.UpdateFilamentRequest} returns this
 */
proto.acompanha.filaments.v1.UpdateFilamentRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string type = 2;
 * @return {string}
 */
proto.acompanha.filaments.v1.UpdateFilamentRequest.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.UpdateFilamentRequest} returns this
 */
proto.acompanha.filaments.v1.UpdateFilamentRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string color = 3;
 * @return {string}
 */
proto.acompanha.filaments.v1.UpdateFilamentRequest.prototype.getColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.UpdateFilamentRequest} returns this
 */
proto.acompanha.filaments.v1.UpdateFilamentRequest.prototype.setColor = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string brand = 4;
 * @return {string}
 */
proto.acompanha.filaments.v1.UpdateFilamentRequest.prototype.getBrand = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.UpdateFilamentRequest} returns this
 */
proto.acompanha.filaments.v1.UpdateFilamentRequest.prototype.setBrand = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional double spool_weight = 5;
 * @return {number}
 */
proto.acompanha.filaments.v1.UpdateFilamentRequest.prototype.getSpoolWeight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.filaments.v1.UpdateFilamentRequest} returns this
 */
proto.acompanha.filaments.v1.UpdateFilamentRequest.prototype.setSpoolWeight = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double current_weight = 6;
 * @return {number}
 */
proto.acompanha.filaments.v1.UpdateFilamentRequest.prototype.getCurrentWeight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.filaments.v1.UpdateFilamentRequest} returns this
 */
proto.acompanha.filaments.v1.UpdateFilamentRequest.prototype.setCurrentWeight = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional int64 cost = 7;
 * @return {number}
 */
proto.acompanha.filaments.v1.UpdateFilamentRequest.prototype.getCost = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.filaments.v1.UpdateFilamentRequest} returns this
 */
proto.acompanha.filaments.v1.UpdateFilamentRequest.prototype.setCost = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string color_label = 8;
 * @return {string}
 */
proto.acompanha.filaments.v1.UpdateFilamentRequest.prototype.getColorLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.UpdateFilamentRequest} returns this
 */
proto.acompanha.filaments.v1.UpdateFilamentRequest.prototype.setColorLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.filaments.v1.UpdateFilamentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.filaments.v1.UpdateFilamentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.filaments.v1.UpdateFilamentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.UpdateFilamentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.filaments.v1.Filament.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.filaments.v1.UpdateFilamentResponse}
 */
proto.acompanha.filaments.v1.UpdateFilamentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.filaments.v1.UpdateFilamentResponse;
  return proto.acompanha.filaments.v1.UpdateFilamentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.filaments.v1.UpdateFilamentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.filaments.v1.UpdateFilamentResponse}
 */
proto.acompanha.filaments.v1.UpdateFilamentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.filaments.v1.Filament;
      reader.readMessage(value,proto.acompanha.filaments.v1.Filament.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.filaments.v1.UpdateFilamentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.filaments.v1.UpdateFilamentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.filaments.v1.UpdateFilamentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.UpdateFilamentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.filaments.v1.Filament.serializeBinaryToWriter
    );
  }
};


/**
 * optional Filament data = 1;
 * @return {?proto.acompanha.filaments.v1.Filament}
 */
proto.acompanha.filaments.v1.UpdateFilamentResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.filaments.v1.Filament} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.filaments.v1.Filament, 1));
};


/**
 * @param {?proto.acompanha.filaments.v1.Filament|undefined} value
 * @return {!proto.acompanha.filaments.v1.UpdateFilamentResponse} returns this
*/
proto.acompanha.filaments.v1.UpdateFilamentResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.filaments.v1.UpdateFilamentResponse} returns this
 */
proto.acompanha.filaments.v1.UpdateFilamentResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.filaments.v1.UpdateFilamentResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.filaments.v1.DeleteFilamentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.filaments.v1.DeleteFilamentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.filaments.v1.DeleteFilamentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.DeleteFilamentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.filaments.v1.DeleteFilamentRequest}
 */
proto.acompanha.filaments.v1.DeleteFilamentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.filaments.v1.DeleteFilamentRequest;
  return proto.acompanha.filaments.v1.DeleteFilamentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.filaments.v1.DeleteFilamentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.filaments.v1.DeleteFilamentRequest}
 */
proto.acompanha.filaments.v1.DeleteFilamentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.filaments.v1.DeleteFilamentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.filaments.v1.DeleteFilamentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.filaments.v1.DeleteFilamentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.DeleteFilamentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.filaments.v1.DeleteFilamentRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.DeleteFilamentRequest} returns this
 */
proto.acompanha.filaments.v1.DeleteFilamentRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.filaments.v1.SetFilamentArchivedRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.filaments.v1.SetFilamentArchivedRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.filaments.v1.SetFilamentArchivedRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.SetFilamentArchivedRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
archived: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.filaments.v1.SetFilamentArchivedRequest}
 */
proto.acompanha.filaments.v1.SetFilamentArchivedRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.filaments.v1.SetFilamentArchivedRequest;
  return proto.acompanha.filaments.v1.SetFilamentArchivedRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.filaments.v1.SetFilamentArchivedRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.filaments.v1.SetFilamentArchivedRequest}
 */
proto.acompanha.filaments.v1.SetFilamentArchivedRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setArchived(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.filaments.v1.SetFilamentArchivedRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.filaments.v1.SetFilamentArchivedRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.filaments.v1.SetFilamentArchivedRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.SetFilamentArchivedRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getArchived();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.filaments.v1.SetFilamentArchivedRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.SetFilamentArchivedRequest} returns this
 */
proto.acompanha.filaments.v1.SetFilamentArchivedRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool archived = 2;
 * @return {boolean}
 */
proto.acompanha.filaments.v1.SetFilamentArchivedRequest.prototype.getArchived = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.filaments.v1.SetFilamentArchivedRequest} returns this
 */
proto.acompanha.filaments.v1.SetFilamentArchivedRequest.prototype.setArchived = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.filaments.v1.SetFilamentArchivedResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.filaments.v1.SetFilamentArchivedResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.filaments.v1.SetFilamentArchivedResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.SetFilamentArchivedResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.filaments.v1.Filament.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.filaments.v1.SetFilamentArchivedResponse}
 */
proto.acompanha.filaments.v1.SetFilamentArchivedResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.filaments.v1.SetFilamentArchivedResponse;
  return proto.acompanha.filaments.v1.SetFilamentArchivedResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.filaments.v1.SetFilamentArchivedResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.filaments.v1.SetFilamentArchivedResponse}
 */
proto.acompanha.filaments.v1.SetFilamentArchivedResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.filaments.v1.Filament;
      reader.readMessage(value,proto.acompanha.filaments.v1.Filament.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.filaments.v1.SetFilamentArchivedResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.filaments.v1.SetFilamentArchivedResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.filaments.v1.SetFilamentArchivedResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.SetFilamentArchivedResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.filaments.v1.Filament.serializeBinaryToWriter
    );
  }
};


/**
 * optional Filament data = 1;
 * @return {?proto.acompanha.filaments.v1.Filament}
 */
proto.acompanha.filaments.v1.SetFilamentArchivedResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.filaments.v1.Filament} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.filaments.v1.Filament, 1));
};


/**
 * @param {?proto.acompanha.filaments.v1.Filament|undefined} value
 * @return {!proto.acompanha.filaments.v1.SetFilamentArchivedResponse} returns this
*/
proto.acompanha.filaments.v1.SetFilamentArchivedResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.filaments.v1.SetFilamentArchivedResponse} returns this
 */
proto.acompanha.filaments.v1.SetFilamentArchivedResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.filaments.v1.SetFilamentArchivedResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.filaments.v1.FilamentUsage.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.filaments.v1.FilamentUsage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.filaments.v1.FilamentUsage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.FilamentUsage.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
filamentUuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
jobUuid: jspb.Message.getFieldWithDefault(msg, 3, ""),
grams: jspb.Message.getFieldWithDefault(msg, 4, 0),
costPerKilogram: jspb.Message.getFieldWithDefault(msg, 5, 0),
jobFileName: jspb.Message.getFieldWithDefault(msg, 6, ""),
jobStatus: jspb.Message.getFieldWithDefault(msg, 7, ""),
printerName: jspb.Message.getFieldWithDefault(msg, 8, ""),
jobStartedAt: (f = msg.getJobStartedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
jobFinishedAt: (f = msg.getJobFinishedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.filaments.v1.FilamentUsage}
 */
proto.acompanha.filaments.v1.FilamentUsage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.filaments.v1.FilamentUsage;
  return proto.acompanha.filaments.v1.FilamentUsage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.filaments.v1.FilamentUsage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.filaments.v1.FilamentUsage}
 */
proto.acompanha.filaments.v1.FilamentUsage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilamentUuid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobUuid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setGrams(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCostPerKilogram(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobFileName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobStatus(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterName(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setJobStartedAt(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setJobFinishedAt(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.filaments.v1.FilamentUsage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.filaments.v1.FilamentUsage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.filaments.v1.FilamentUsage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.FilamentUsage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilamentUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getJobUuid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getGrams();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getCostPerKilogram();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getJobFileName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getJobStatus();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPrinterName();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getJobStartedAt();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getJobFinishedAt();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.filaments.v1.FilamentUsage.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.FilamentUsage} returns this
 */
proto.acompanha.filaments.v1.FilamentUsage.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string filament_uuid = 2;
 * @return {string}
 */
proto.acompanha.filaments.v1.FilamentUsage.prototype.getFilamentUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.FilamentUsage} returns this
 */
proto.acompanha.filaments.v1.FilamentUsage.prototype.setFilamentUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string job_uuid = 3;
 * @return {string}
 */
proto.acompanha.filaments.v1.FilamentUsage.prototype.getJobUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.FilamentUsage} returns this
 */
proto.acompanha.filaments.v1.FilamentUsage.prototype.setJobUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 grams = 4;
 * @return {number}
 */
proto.acompanha.filaments.v1.FilamentUsage.prototype.getGrams = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.filaments.v1.FilamentUsage} returns this
 */
proto.acompanha.filaments.v1.FilamentUsage.prototype.setGrams = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 cost_per_kilogram = 5;
 * @return {number}
 */
proto.acompanha.filaments.v1.FilamentUsage.prototype.getCostPerKilogram = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.filaments.v1.FilamentUsage} returns this
 */
proto.acompanha.filaments.v1.FilamentUsage.prototype.setCostPerKilogram = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string job_file_name = 6;
 * @return {string}
 */
proto.acompanha.filaments.v1.FilamentUsage.prototype.getJobFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.FilamentUsage} returns this
 */
proto.acompanha.filaments.v1.FilamentUsage.prototype.setJobFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string job_status = 7;
 * @return {string}
 */
proto.acompanha.filaments.v1.FilamentUsage.prototype.getJobStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.FilamentUsage} returns this
 */
proto.acompanha.filaments.v1.FilamentUsage.prototype.setJobStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string printer_name = 8;
 * @return {string}
 */
proto.acompanha.filaments.v1.FilamentUsage.prototype.getPrinterName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.FilamentUsage} returns this
 */
proto.acompanha.filaments.v1.FilamentUsage.prototype.setPrinterName = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional google.protobuf.Timestamp job_started_at = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.filaments.v1.FilamentUsage.prototype.getJobStartedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.filaments.v1.FilamentUsage} returns this
*/
proto.acompanha.filaments.v1.FilamentUsage.prototype.setJobStartedAt = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.filaments.v1.FilamentUsage} returns this
 */
proto.acompanha.filaments.v1.FilamentUsage.prototype.clearJobStartedAt = function() {
  return this.setJobStartedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.filaments.v1.FilamentUsage.prototype.hasJobStartedAt = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.Timestamp job_finished_at = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.filaments.v1.FilamentUsage.prototype.getJobFinishedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.filaments.v1.FilamentUsage} returns this
*/
proto.acompanha.filaments.v1.FilamentUsage.prototype.setJobFinishedAt = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.filaments.v1.FilamentUsage} returns this
 */
proto.acompanha.filaments.v1.FilamentUsage.prototype.clearJobFinishedAt = function() {
  return this.setJobFinishedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.filaments.v1.FilamentUsage.prototype.hasJobFinishedAt = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.Timestamp created_at = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.filaments.v1.FilamentUsage.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.filaments.v1.FilamentUsage} returns this
*/
proto.acompanha.filaments.v1.FilamentUsage.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.filaments.v1.FilamentUsage} returns this
 */
proto.acompanha.filaments.v1.FilamentUsage.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.filaments.v1.FilamentUsage.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 11) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.filaments.v1.ListFilamentUsagesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.filaments.v1.ListFilamentUsagesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.filaments.v1.ListFilamentUsagesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.ListFilamentUsagesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
filamentUuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
pagination: (f = msg.getPagination()) && acompanha_common_v1_common_pb.PaginationRequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.filaments.v1.ListFilamentUsagesRequest}
 */
proto.acompanha.filaments.v1.ListFilamentUsagesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.filaments.v1.ListFilamentUsagesRequest;
  return proto.acompanha.filaments.v1.ListFilamentUsagesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.filaments.v1.ListFilamentUsagesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.filaments.v1.ListFilamentUsagesRequest}
 */
proto.acompanha.filaments.v1.ListFilamentUsagesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilamentUuid(value);
      break;
    case 2:
      var value = new acompanha_common_v1_common_pb.PaginationRequest;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaginationRequest.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.filaments.v1.ListFilamentUsagesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.filaments.v1.ListFilamentUsagesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.filaments.v1.ListFilamentUsagesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.ListFilamentUsagesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilamentUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      acompanha_common_v1_common_pb.PaginationRequest.serializeBinaryToWriter
    );
  }
};


/**
 * optional string filament_uuid = 1;
 * @return {string}
 */
proto.acompanha.filaments.v1.ListFilamentUsagesRequest.prototype.getFilamentUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.ListFilamentUsagesRequest} returns this
 */
proto.acompanha.filaments.v1.ListFilamentUsagesRequest.prototype.setFilamentUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional acompanha.common.v1.PaginationRequest pagination = 2;
 * @return {?proto.acompanha.common.v1.PaginationRequest}
 */
proto.acompanha.filaments.v1.ListFilamentUsagesRequest.prototype.getPagination = function() {
  return /** @type{?proto.acompanha.common.v1.PaginationRequest} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaginationRequest, 2));
};


/**
 * @param {?proto.acompanha.common.v1.PaginationRequest|undefined} value
 * @return {!proto.acompanha.filaments.v1.ListFilamentUsagesRequest} returns this
*/
proto.acompanha.filaments.v1.ListFilamentUsagesRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.filaments.v1.ListFilamentUsagesRequest} returns this
 */
proto.acompanha.filaments.v1.ListFilamentUsagesRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.filaments.v1.ListFilamentUsagesRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.filaments.v1.ListFilamentUsagesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.filaments.v1.ListFilamentUsagesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.filaments.v1.ListFilamentUsagesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.filaments.v1.ListFilamentUsagesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.ListFilamentUsagesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
usagesList: jspb.Message.toObjectList(msg.getUsagesList(),
    proto.acompanha.filaments.v1.FilamentUsage.toObject, includeInstance),
meta: (f = msg.getMeta()) && acompanha_common_v1_common_pb.PaginationMeta.toObject(includeInstance, f),
totalGrams: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.filaments.v1.ListFilamentUsagesResponse}
 */
proto.acompanha.filaments.v1.ListFilamentUsagesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.filaments.v1.ListFilamentUsagesResponse;
  return proto.acompanha.filaments.v1.ListFilamentUsagesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.filaments.v1.ListFilamentUsagesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.filaments.v1.ListFilamentUsagesResponse}
 */
proto.acompanha.filaments.v1.ListFilamentUsagesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.filaments.v1.FilamentUsage;
      reader.readMessage(value,proto.acompanha.filaments.v1.FilamentUsage.deserializeBinaryFromReader);
      msg.addUsages(value);
      break;
    case 2:
      var value = new acompanha_common_v1_common_pb.PaginationMeta;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaginationMeta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalGrams(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.filaments.v1.ListFilamentUsagesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.filaments.v1.ListFilamentUsagesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.filaments.v1.ListFilamentUsagesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.ListFilamentUsagesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.acompanha.filaments.v1.FilamentUsage.serializeBinaryToWriter
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      acompanha_common_v1_common_pb.PaginationMeta.serializeBinaryToWriter
    );
  }
  f = message.getTotalGrams();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * repeated FilamentUsage usages = 1;
 * @return {!Array<!proto.acompanha.filaments.v1.FilamentUsage>}
 */
proto.acompanha.filaments.v1.ListFilamentUsagesResponse.prototype.getUsagesList = function() {
  return /** @type{!Array<!proto.acompanha.filaments.v1.FilamentUsage>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.filaments.v1.FilamentUsage, 1));
};


/**
 * @param {!Array<!proto.acompanha.filaments.v1.FilamentUsage>} value
 * @return {!proto.acompanha.filaments.v1.ListFilamentUsagesResponse} returns this
*/
proto.acompanha.filaments.v1.ListFilamentUsagesResponse.prototype.setUsagesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.acompanha.filaments.v1.FilamentUsage=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.filaments.v1.FilamentUsage}
 */
proto.acompanha.filaments.v1.ListFilamentUsagesResponse.prototype.addUsages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.acompanha.filaments.v1.FilamentUsage, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.filaments.v1.ListFilamentUsagesResponse} returns this
 */
proto.acompanha.filaments.v1.ListFilamentUsagesResponse.prototype.clearUsagesList = function() {
  return this.setUsagesList([]);
};


/**
 * optional acompanha.common.v1.PaginationMeta meta = 2;
 * @return {?proto.acompanha.common.v1.PaginationMeta}
 */
proto.acompanha.filaments.v1.ListFilamentUsagesResponse.prototype.getMeta = function() {
  return /** @type{?proto.acompanha.common.v1.PaginationMeta} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaginationMeta, 2));
};


/**
 * @param {?proto.acompanha.common.v1.PaginationMeta|undefined} value
 * @return {!proto.acompanha.filaments.v1.ListFilamentUsagesResponse} returns this
*/
proto.acompanha.filaments.v1.ListFilamentUsagesResponse.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.filaments.v1.ListFilamentUsagesResponse} returns this
 */
proto.acompanha.filaments.v1.ListFilamentUsagesResponse.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.filaments.v1.ListFilamentUsagesResponse.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 total_grams = 3;
 * @return {number}
 */
proto.acompanha.filaments.v1.ListFilamentUsagesResponse.prototype.getTotalGrams = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.filaments.v1.ListFilamentUsagesResponse} returns this
 */
proto.acompanha.filaments.v1.ListFilamentUsagesResponse.prototype.setTotalGrams = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.filaments.v1.FilamentPrinterAssignInput.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.filaments.v1.FilamentPrinterAssignInput.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.filaments.v1.FilamentPrinterAssignInput} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.FilamentPrinterAssignInput.toObject = function(includeInstance, msg) {
  var f, obj = {
printerUuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
location: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.filaments.v1.FilamentPrinterAssignInput}
 */
proto.acompanha.filaments.v1.FilamentPrinterAssignInput.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.filaments.v1.FilamentPrinterAssignInput;
  return proto.acompanha.filaments.v1.FilamentPrinterAssignInput.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.filaments.v1.FilamentPrinterAssignInput} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.filaments.v1.FilamentPrinterAssignInput}
 */
proto.acompanha.filaments.v1.FilamentPrinterAssignInput.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.filaments.v1.FilamentPrinterAssignInput.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.filaments.v1.FilamentPrinterAssignInput.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.filaments.v1.FilamentPrinterAssignInput} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.FilamentPrinterAssignInput.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrinterUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLocation();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string printer_uuid = 1;
 * @return {string}
 */
proto.acompanha.filaments.v1.FilamentPrinterAssignInput.prototype.getPrinterUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.FilamentPrinterAssignInput} returns this
 */
proto.acompanha.filaments.v1.FilamentPrinterAssignInput.prototype.setPrinterUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string location = 2;
 * @return {string}
 */
proto.acompanha.filaments.v1.FilamentPrinterAssignInput.prototype.getLocation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.FilamentPrinterAssignInput} returns this
 */
proto.acompanha.filaments.v1.FilamentPrinterAssignInput.prototype.setLocation = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.filaments.v1.AssignFilamentToPrintersRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.filaments.v1.AssignFilamentToPrintersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.filaments.v1.AssignFilamentToPrintersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.filaments.v1.AssignFilamentToPrintersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.AssignFilamentToPrintersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
filamentUuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
assignmentsList: jspb.Message.toObjectList(msg.getAssignmentsList(),
    proto.acompanha.filaments.v1.FilamentPrinterAssignInput.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.filaments.v1.AssignFilamentToPrintersRequest}
 */
proto.acompanha.filaments.v1.AssignFilamentToPrintersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.filaments.v1.AssignFilamentToPrintersRequest;
  return proto.acompanha.filaments.v1.AssignFilamentToPrintersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.filaments.v1.AssignFilamentToPrintersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.filaments.v1.AssignFilamentToPrintersRequest}
 */
proto.acompanha.filaments.v1.AssignFilamentToPrintersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilamentUuid(value);
      break;
    case 2:
      var value = new proto.acompanha.filaments.v1.FilamentPrinterAssignInput;
      reader.readMessage(value,proto.acompanha.filaments.v1.FilamentPrinterAssignInput.deserializeBinaryFromReader);
      msg.addAssignments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.filaments.v1.AssignFilamentToPrintersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.filaments.v1.AssignFilamentToPrintersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.filaments.v1.AssignFilamentToPrintersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.AssignFilamentToPrintersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilamentUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAssignmentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.acompanha.filaments.v1.FilamentPrinterAssignInput.serializeBinaryToWriter
    );
  }
};


/**
 * optional string filament_uuid = 1;
 * @return {string}
 */
proto.acompanha.filaments.v1.AssignFilamentToPrintersRequest.prototype.getFilamentUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.filaments.v1.AssignFilamentToPrintersRequest} returns this
 */
proto.acompanha.filaments.v1.AssignFilamentToPrintersRequest.prototype.setFilamentUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated FilamentPrinterAssignInput assignments = 2;
 * @return {!Array<!proto.acompanha.filaments.v1.FilamentPrinterAssignInput>}
 */
proto.acompanha.filaments.v1.AssignFilamentToPrintersRequest.prototype.getAssignmentsList = function() {
  return /** @type{!Array<!proto.acompanha.filaments.v1.FilamentPrinterAssignInput>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.filaments.v1.FilamentPrinterAssignInput, 2));
};


/**
 * @param {!Array<!proto.acompanha.filaments.v1.FilamentPrinterAssignInput>} value
 * @return {!proto.acompanha.filaments.v1.AssignFilamentToPrintersRequest} returns this
*/
proto.acompanha.filaments.v1.AssignFilamentToPrintersRequest.prototype.setAssignmentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.acompanha.filaments.v1.FilamentPrinterAssignInput=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.filaments.v1.FilamentPrinterAssignInput}
 */
proto.acompanha.filaments.v1.AssignFilamentToPrintersRequest.prototype.addAssignments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.acompanha.filaments.v1.FilamentPrinterAssignInput, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.filaments.v1.AssignFilamentToPrintersRequest} returns this
 */
proto.acompanha.filaments.v1.AssignFilamentToPrintersRequest.prototype.clearAssignmentsList = function() {
  return this.setAssignmentsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.filaments.v1.AssignFilamentToPrintersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.filaments.v1.AssignFilamentToPrintersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.filaments.v1.AssignFilamentToPrintersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.AssignFilamentToPrintersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.filaments.v1.AssignFilamentToPrintersResponse}
 */
proto.acompanha.filaments.v1.AssignFilamentToPrintersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.filaments.v1.AssignFilamentToPrintersResponse;
  return proto.acompanha.filaments.v1.AssignFilamentToPrintersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.filaments.v1.AssignFilamentToPrintersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.filaments.v1.AssignFilamentToPrintersResponse}
 */
proto.acompanha.filaments.v1.AssignFilamentToPrintersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.filaments.v1.AssignFilamentToPrintersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.filaments.v1.AssignFilamentToPrintersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.filaments.v1.AssignFilamentToPrintersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.filaments.v1.AssignFilamentToPrintersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.acompanha.filaments.v1.AssignFilamentToPrintersResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.filaments.v1.AssignFilamentToPrintersResponse} returns this
 */
proto.acompanha.filaments.v1.AssignFilamentToPrintersResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


goog.object.extend(exports, proto.acompanha.filaments.v1);
